import { Select, createListCollection } from "@chakra-ui/react";

type Props = {
  options: string[];
  selectedOption?: string;
  onSelect: (option: string | undefined) => void;
  placeholder?: string;
  width?: string | number;
  isClearable?: boolean;
};

const SelectFilter = ({
  options,
  selectedOption,
  onSelect,
  placeholder = "Select an option",
  width = "100%",
  isClearable = true,
}: Props): JSX.Element => {
  const collection = createListCollection({
    items: options.map((option) => ({ label: option, value: option })),
  });

  const handleValueChange = (details: { value: string[] }) => {
    const selectedValue = details.value[0];
    onSelect(selectedValue || undefined);
  };

  return (
    <Select.Root
      loopFocus
      collection={collection}
      value={selectedOption ? [selectedOption] : []}
      onValueChange={handleValueChange}
      width={width}
      deselectable={isClearable}
      size="sm"
    >
      <Select.Control>
        <Select.Trigger ring="palomma.500" focusRing="outside">
          <Select.ValueText placeholder={placeholder} />
        </Select.Trigger>
        <Select.IndicatorGroup>
          {isClearable && <Select.ClearTrigger cursor="pointer" />}
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Select.Positioner>
        <Select.Content>
          {collection.items.map((item) => (
            <Select.Item key={item.value} item={item}>
              {item.label}
              <Select.ItemIndicator />
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>
  );
};

export default SelectFilter;
